// extracted by mini-css-extract-plugin
export default {"questions":"show_questions__MX0kB"};